namespace GeniuzPOS.InventoryReport {
    export class IcReport04_VColumns {
        static columnsKey = 'InventoryReport.IcReport04_V';
    }
}
